/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from 'react';

import { IRosreestrInfo } from '../../../types/offerData';
import { trackInfoExpand } from '../tracking';

const COLLAPSED_MAX_ROWS = 3;

const showFullInfo = (rosreestrInfo?: IRosreestrInfo | null) =>
  !rosreestrInfo ||
  (rosreestrInfo.parts[0].elements.length <= COLLAPSED_MAX_ROWS && !rosreestrInfo.parts[1]?.elements.length);

export const useFormattedInfo = (rosreestrInfo?: IRosreestrInfo | null) => {
  const [expanded, setExpanded] = React.useState(showFullInfo(rosreestrInfo));

  const handleInfoExpand = React.useCallback(() => {
    setExpanded(true);

    trackInfoExpand();
  }, [setExpanded]);

  return React.useMemo(
    () =>
      expanded
        ? {
            formattedInfo: rosreestrInfo,
            onExpand: handleInfoExpand,
            showExpandButton: false,
          }
        : {
            formattedInfo: {
              ...rosreestrInfo,
              parts: [
                {
                  ...rosreestrInfo!.parts[0],
                  elements: rosreestrInfo!.parts[0].elements.slice(0, COLLAPSED_MAX_ROWS),
                },
              ],
            } as IRosreestrInfo,
            onExpand: handleInfoExpand,
            showExpandButton: true,
          },
    [expanded, handleInfoExpand, rosreestrInfo],
  );
};
